// src/components/LatestEvents.js
import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import config from '../config/config';
import EventCard from './EventCard';

const LatestEvents = () => {
  const [events, setEvents] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchEvents = async () => {
      try {
        setLoading(true);
        // Ensure consistent API path with /api prefix
        const response = await axios.get(`${config.BASE_URL}/api/events/latest`);
        
        // Map response data to match EventCard's expected format if needed
        const formattedEvents = response.data.map(event => ({
          id: event.id,
          event_title: event.title || event.event_title,
          event_summary: event.summary || event.event_summary || event.description || '',
          event_graphic: event.image_url || event.event_graphic || '',
          event_date: event.date || event.event_date
        }));
        
        setEvents(formattedEvents);
        setLoading(false);
      } catch (err) {
        console.error('Error fetching latest events:', err);
        setError('Failed to load latest events');
        setLoading(false);
      }
    };

    fetchEvents();
  }, []);

  useEffect(() => {
    const fetchLatestEvents = async () => {
      try {
        // Add cache busting parameter
        const response = await fetch(`${config.BASE_URL}/api/events/latest?t=${Date.now()}`);
        const data = await response.json();
        setEvents(data);
      } catch (error) {
        console.error('Error fetching latest events:', error);
      }
    };

    fetchLatestEvents();

    // Listen for event updates from admin dashboard
    const handleEventUpdate = () => {
      fetchLatestEvents();
    };

    window.addEventListener('eventDataUpdated', handleEventUpdate);
    
    return () => {
      window.removeEventListener('eventDataUpdated', handleEventUpdate);
    };
  }, []);

  if (loading) return <div className="text-center">Loading latest events...</div>;
  if (error) return <div className="text-center text-danger">{error}</div>;
  if (events.length === 0) return <div className="text-center">No latest events found</div>;

  return (
    <section id="latest" className="pt-4 pb-5">
      {/* Removed bg-light class to match UpcomingEvents styling */}
      <div className="container">
        <div className="row trend_1">
          <div className="col-md-6 col-6">
            <div className="trend_1l">
              <h4 className="mb-0 text-white">
                <i className="fa fa-clock-o align-middle col_red me-1"></i>
                Latest <span className="col_red">Events</span>
              </h4>
            </div>
          </div>
          <div className="col-md-6 col-6">
            <div className="trend_1r text-end">
              <h6 className="mb-0">
                <Link className="button" to="/events">
                  View All
                </Link>
              </h6>
            </div>
          </div>
        </div>
        <div className="row mt-4">
          {events.map((event) => (
            <EventCard key={event.id} event={event} />
          ))}
        </div>
      </div>
    </section>
  );
};

export default LatestEvents;
